module.exports = __webpack_public_path__ + "static/media/light-divider.702cf30e.png";